export const PAGINATION_LIMIT = 25

export const NYC_ORGANIZATION_ID = '6966036a-12d4-4a57-a2ad-c119d797edd1'
export const DRIVERS_UNION_ID = '1f0636ef-588f-4dbd-ab55-114750af7dc2'
export const UNION360 = '6b007544-3832-4a1f-a47a-e07535e3b2ec'

export const ALL_ORGANIZATION_NAMES = [
  'wbf',
  'bcf-new-york',
  'idg-illinois',
  'drivers-union',
  'demonstration-org',
  'drivers-demand-justice',
  'union360',
  'idg-connecticut',
  'idg-florida',
  'idg-state-is-not-listed',
  'idg-machinists-union',
  'idg-new-jersey',
  'benestream',
  'idg-new-york',
  'iam-wisconsin',
  'iam-midwest',
]

export const LANGUAGES_FOR_LOCATIONS = [
  { label: 'Albanian', value: 'sq' },
  { label: 'Arabic', value: 'ar' },
  { label: 'Armenian', value: 'hy' },
  { label: 'Bengali', value: 'bn' },
  { label: 'Cantonese Chinese', value: 'yue' },
  { label: 'Chinese (unspecified)', value: 'zh' },
  { label: 'Dutch', value: 'nl' },
  { label: 'English', value: 'en' },
  { label: 'Farsi', value: 'fa' },
  { label: 'Filipino', value: 'fil' },
  { label: 'French', value: 'fr' },
  { label: 'German', value: 'de' },
  { label: 'Georgian', value: 'ka' },
  { label: 'Greek', value: 'el' },
  { label: 'Gujarati', value: 'gu' },
  { label: 'Haitian Creole', value: 'ht' },
  { label: 'Hebrew', value: 'he' },
  { label: 'Hindi', value: 'hi' },
  { label: 'Indonesian', value: 'id' },
  { label: 'Italian', value: 'it' },
  { label: 'Japanese', value: 'ja' },
  { label: 'Korean', value: 'ko' },
  { label: 'Mandarin Chinese', value: 'zh-mn' },
  { label: 'Nepali', value: 'ne' },
  { label: 'Panjabi', value: 'pa' },
  { label: 'Polish', value: 'pl' },
  { label: 'Portuguese', value: 'pt' },
  { label: 'Romanian', value: 'ro' },
  { label: 'Russian', value: 'ru' },
  { label: 'Somali', value: 'so' },
  { label: 'Spanish', value: 'es' },
  { label: 'Tagalog', value: 'tl' },
  { label: 'Turkish', value: 'tr' },
  { label: 'Ukrainian', value: 'uk' },
  { label: 'Urdu', value: 'ur' },
  { label: 'Uzbek', value: 'uz' },
  { label: 'Yiddish', value: 'yi' },
]

export const PARKING_AVAILABILITY_SELECT = [
  { label: 'Paid Parking Lot', value: 'PAID_PARKING_LOT' },
  { label: 'Free Parking Lot', value: 'FREE_PARKING_LOT' },
  { label: 'Paid Parking Garage', value: 'PAID_PARKING_GARAGE' },
  { label: 'Free Parking Garage', value: 'FREE_PARKING_GARAGE' },
  {
    label: 'Metered Street Parking',
    value: 'METERED_STREET_PARKING',
  },
  { label: 'Free Street Parking', value: 'FREE_STREET_PARKING' },
  {
    label: 'No Parking Information Available',
    value: 'NO_PARKING_INFORMATION_AVAILABLE',
  },
]

export const SPECIALTY_OPTIONS = [
  'Dental Anesthesiology',
  'Dental Public Health',
  'Endodontics',
  'Oral and Maxillofacial Pathology',
  'Oral and Maxillofacial Radiology',
  'Oral and Maxillofacial Surgery',
  'Oral Medicine',
  'Orofacial Pain',
  'Orthodontics and Dentofacial Orthopedics',
  'Periodontics',
  'Prosthodontics',
  'General Dentistry',
]

export const CLINIC_TYPES = [
  { label: 'Dental', value: 'DENTAL' },
  { label: 'Vision', value: 'VISION' },
  {
    label: 'Health Navigation - Initial Health Assessment',
    value: 'HEALTH NAVIGATION - INITIAL HEALTH ASSESSMENT',
  },
  {
    label: 'Health Navigation - Continued Care',
    value: 'HEALTH NAVIGATION - CONTINUED CARE',
  },
  {
    label: 'Health Navigation - Uninsured Driver',
    value: 'HEALTH NAVIGATION - UNINSURED DRIVER',
  },
]

export const TNC_SOURCES = ['Uber', 'Lyft', 'HopSkipDrive', 'Via']
export const QUARTERS = ['Q1', 'Q2', 'Q3', 'Q4']
